import React, { useMemo, useState } from 'react';
import MenuItem from '../../MenuItem/MenuItem';
import { useRecoilValue } from 'recoil';
import { roleAccessState } from '../../../../../../../atoms/auth/auth.atom';
import { hasRoleAccess } from '../../../../../../../utils/access/access';
import { HttpMethod } from '../../../../../../../domain/Role';
import PdfPreviewDialog from '../../../../../../Dialog/PdfPreviewDialog/PdfPreviewDialog';
import { translate } from '../../../../../../../utils/translation/translation';
import { translationsState } from '../../../../../../../atoms/translation/translation.atom';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { SetValues } from '../../../../../../../hooks/useForm/useForm';

export type PdfPreviewActionAccess = {
  url: string;
  method: HttpMethod;
};

export type PdfPreviewActionProps = {
  title: string;
  subtitle?: string;
  baseApiUrl?: string;
  id?: string;
  valueKey?: string;
  apiUrl?: string;
  readUrl?: string;
  readLabel?: string;
  onSuccess?: (data?: SetValues) => void;
  label?: string;
  access?: PdfPreviewActionAccess;
  addFileName?: boolean;
};

export const PdfPreviewAction = ({
  title,
  subtitle,
  baseApiUrl,
  id,
  apiUrl,
  readUrl,
  readLabel,
  onSuccess,
  label,
  access,
  addFileName,
}: PdfPreviewActionProps) => {
  const translations = useRecoilValue(translationsState);
  const roleAccessValue = useRecoilValue(roleAccessState);
  const [isOpen, setIsOpen] = useState(false);

  const isDisabled = useMemo(() => {
    if (access) {
      return !hasRoleAccess(roleAccessValue, access.method, access.url);
    }

    if (!baseApiUrl) {
      return false;
    }

    return !hasRoleAccess(roleAccessValue, HttpMethod.GET, `${baseApiUrl}/:id`);
  }, [baseApiUrl, access]);

  const handleOpen = (e: any) => {
    e.stopPropagation();
    setIsOpen(true);
  };

  return (
    <>
      <MenuItem onClick={handleOpen} disabled={isDisabled}>
        <PictureAsPdfIcon width={20} height={20} />
        {label ?? translate(translations, 'PDF_PREVIEW_ACTION.PREVIEW')}
      </MenuItem>
      {isOpen && (
        <PdfPreviewDialog
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          title={title}
          id={id ?? ''}
          apiUrl={apiUrl}
          subtitle={subtitle}
          readUrl={readUrl}
          readLabel={readLabel}
          onSuccess={onSuccess}
          addFileName={addFileName}
        />
      )}
    </>
  );
};

export default PdfPreviewAction;
